// =============================================================================
// OmniVoice — client feature flag + gateway endpoint (shell side)
//
// DEFAULT-OFF, mirroring the gateway. With VITE_OMNIVOICE_ENABLED unset the
// realtime path is never attempted and the voice surface behaves EXACTLY like
// today's turn-based Whisper→LLM→TTS session.
// =============================================================================

/** True only when the realtime path is explicitly enabled for the shell. */
export function isOmniVoiceEnabled(): boolean {
  const v = import.meta.env.VITE_OMNIVOICE_ENABLED;
  return v === 'true' || v === '1';
}

/**
 * Opt-in for the OpenAI realtime RELAY fallback (omnivoice-gateway). DEFAULT-OFF
 * and SEPARATE from VITE_OMNIVOICE_ENABLED.
 *
 * Why a second gate: the relay is NOT yet tenant-aware — it does not inject the
 * NEXUS persona or durable recall into the realtime session.instructions, so a
 * session that lands there answers WITHOUT the tenant's data ("voice nie widzi
 * danych"). Until the relay is made tenant-aware, a mint timeout/error must drop
 * to the brain-backed turn-based path (which calls engine.chat() → recall), not
 * silently degrade to this brain-less relay. Operators who explicitly want the
 * relay can turn it back on here.
 */
export function isOmniVoiceRelayOptIn(): boolean {
  const v = import.meta.env.VITE_OMNIVOICE_RELAY_ENABLED;
  return v === 'true' || v === '1';
}

/**
 * Base URL of the deployed omnivoice-gateway (e.g. https://omnivoice.example).
 * Returns null when unset — the caller then falls back to turn-based voice.
 *
 * NOTE (seam): there is intentionally no shell default here. Enabling realtime
 * requires operators to point this at the deployed gateway; without it we do NOT
 * guess an origin and silently fall back.
 */
export function getOmniVoiceGatewayUrl(): string | null {
  const v = import.meta.env.VITE_OMNIVOICE_GATEWAY_URL;
  return v && v.trim() ? v.trim() : null;
}
